import R from "../../../../../@babel_runtime@7.25.6/node_modules/@babel/runtime/helpers/esm/extends.js";
import _ from "../../../../../@vue_babel-helper-vue-jsx-merge-props@1.4.0/node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.js";
import { inherit as q, emit as b } from "../utils/functional.js";
import { BORDER_SURROUND as D } from "../utils/constant.js";
import { routeProps as N, functionalRoute as O } from "../utils/router.js";
import p from "../icon/index.js";
import I from "../loading/index.js";
import { createNamespace as U } from "../utils/create/index.js";
var v = U("button"),
  w = v[0],
  o = v[1];
function x(n, i, t, l) {
  var f,
    B = i.tag,
    m = i.icon,
    h = i.type,
    a = i.color,
    u = i.plain,
    g = i.disabled,
    c = i.loading,
    s = i.hairline,
    P = i.loadingText,
    y = i.iconPosition,
    r = {};
  a && (r.color = u ? a : "white", u || (r.background = a), a.indexOf("gradient") !== -1 ? r.border = 0 : r.borderColor = a);
  function T(e) {
    i.loading && e.preventDefault(), !c && !g && (b(l, "click", e), O(l));
  }
  function k(e) {
    b(l, "touchstart", e);
  }
  var z = [o([h, i.size, {
    plain: u,
    loading: c,
    disabled: g,
    hairline: s,
    block: i.block,
    round: i.round,
    square: i.square
  }]), (f = {}, f[D] = s, f)];
  function S() {
    if (c) return t.loading ? t.loading() : n(I, {
      class: o("loading"),
      attrs: {
        size: i.loadingSize,
        type: i.loadingType,
        color: "currentColor"
      }
    });
    if (t.icon) return n("div", {
      class: o("icon")
    }, [t.icon()]);
    if (m) return n(p, {
      attrs: {
        name: m,
        classPrefix: i.iconPrefix
      },
      class: o("icon")
    });
  }
  function C() {
    var e = [];
    y === "left" && e.push(S());
    var d;
    return c ? d = P : d = t.default ? t.default() : i.text, d && e.push(n("span", {
      class: o("text")
    }, [d])), y === "right" && e.push(S()), e;
  }
  return n(B, _([{
    style: r,
    class: z,
    attrs: {
      type: i.nativeType,
      disabled: g
    },
    on: {
      click: T,
      touchstart: k
    }
  }, q(l)]), [n("div", {
    class: o("content")
  }, [C()])]);
}
x.props = R({}, N, {
  text: String,
  icon: String,
  color: String,
  block: Boolean,
  plain: Boolean,
  round: Boolean,
  square: Boolean,
  loading: Boolean,
  hairline: Boolean,
  disabled: Boolean,
  iconPrefix: String,
  nativeType: String,
  loadingText: String,
  loadingType: String,
  tag: {
    type: String,
    default: "button"
  },
  type: {
    type: String,
    default: "default"
  },
  size: {
    type: String,
    default: "normal"
  },
  loadingSize: {
    type: String,
    default: "20px"
  },
  iconPosition: {
    type: String,
    default: "left"
  }
});
var G = w(x);
export { G as default };
